export default "https://cdn-static.gokick.com/assets/b11b69440b74c450e5ca5f7ba176f3cdc3a0fffe/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";